import { render } from "./NewsDetail.vue?vue&type=template&id=436dcabb&scoped=true"
import script from "./NewsDetail.vue?vue&type=script&lang=js"
export * from "./NewsDetail.vue?vue&type=script&lang=js"

import "./NewsDetail.vue?vue&type=style&index=0&id=436dcabb&scoped=true&lang=css"
import "./NewsDetail.vue?vue&type=style&index=1&id=436dcabb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-436dcabb"]])

export default __exports__